import { Component, inject } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: true,
    imports: [MatSlideToggleModule,MatToolbarModule,
        MatButtonModule,
        MatIconModule],
})


export class NavbarComponent {
    private keycloak = inject(Keycloak);
    constructor(private router: Router) {
    }

    redirect(){
        this.router.navigate(['/landing-page']);
    }

    logout()
    {
        this.keycloak.logout()
    }
}
